/*
A Vue 3 app, built using components from Algolia Instant Search

Vue 3: https://vuejs.org/guide/introduction.html (select 'Composition' as your API preference)
Algolia Instant Search: https://www.algolia.com/doc/guides/building-search-ui/what-is-instantsearch/vue/

Build tasks:
npm run build:search
gulp search

Watch task:
gulp watchSearch

Config file:
vite.config.search.js
*/

import { createApp } from 'vue';
import App from './search/App.vue';

createApp(App).mount('#tzo-search-app');
